import { Store, Calendar, Package, Truck, BarChart3 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ProducerCapabilityKey } from '@/lib/capabilities';

/**
 * Central definition of sidebar "Funktioner" items.
 * Each entry maps a feature_key (from features_catalog / plan) to
 * a capability requirement and sidebar metadata.
 *
 * To add a new feature: add an entry here — sidebar picks it up automatically.
 */
export interface ProducerFeatureNavItem {
  /** Matches features_catalog.key */
  feature_key: string;
  /** Sidebar label */
  label: string;
  /** Sidebar icon */
  icon: LucideIcon;
  /** Capability required for the feature to be usable (beyond just unlocked) */
  requires_capability: ProducerCapabilityKey;
  /** Relative href suffix (appended to /app/producer/farm/{farmId}) */
  hrefSuffix: string;
  /** Children nav items */
  children?: {
    label: string;
    hrefSuffix: string;
    icon: LucideIcon;
    badgeKey?: string;
  }[];
}

export const PRODUCER_FEATURE_NAV: ProducerFeatureNavItem[] = [
  {
    feature_key: 'events',
    label: 'Aktiviteter',
    icon: Calendar,
    requires_capability: 'manage.events',
    hrefSuffix: '/events',
  },
  {
    /** Gårdsbutik maps to plan_features.feature_key = 'farm_shop' */
    feature_key: 'farm_shop',
    label: 'Gårdsbutik',
    icon: Store,
    requires_capability: 'manage.shop',
    hrefSuffix: '/shop',
    children: [
      { label: 'Produkter', hrefSuffix: '/shop/products', icon: Package },
      { label: 'Ordrar', hrefSuffix: '/shop/orders', icon: Store, badgeKey: 'newOrders' },
      { label: 'Frakt & leverans', hrefSuffix: '/shop/shipping', icon: Truck },
    ],
  },
];
